import CartPopup from './CartPopup';

export default CartPopup;
